<template>
  <complex-select :tb-head="Head" :tb-data="Data" :key-str="keyword" v-model="value1" @select="onSelect" :empty='empty'
    :pageSize="pageParams.pageSize" :pageIndex="pageParams.pageIndex" :listTotal='total' :pageType="pageType" @currentPage="currentPage"
    @inputText="inputText" :disabled="disabled" @changeSelect="changeSelect" :select-list="selectList" :is-select="isSelect"
    :select-key="selectKey" :select-label="selectLabel" placeholder="请输入商品备案名称进行查询" />
</template>
<script>
import complexSelect from "@/components/common/complex-select";
export default {
  components: {
    complexSelect,
  },
  props: {
    selectKey: {
      type: String,
      default: "",
    },
    selectLabel: {
      type: String,
      default: "",
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: Boolean,
      default: false,
    },
    listTotal: {
      type: Number,
      default: undefined,
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    pageIndex: {
      type: Number,
      default: undefined,
    },
    source: {
      type: Array,
      default: () => [],
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    keyword: {
      type: String,
      default: "FilingsName",
    },
    value: {},
    Head: {
      type: Array,
      default: () => {
        return [
          { Value: "FilingsOrderid", Name: "备案商品编号", Width: "150" },
          { Value: "FilingsName", Name: "备案商品名称", Width: "300" },
          { Value: "BrandName", Name: "品牌", Width: "100" },
        //  { Value: "GoodsModel", Name: "规格型号", Width: "150" },
          { Value: "FilingsCategory", Name: "类目", Width: "100" }
        ]
      },
    },
  },
  data() {
    return {
      Data: [],
      total: 0,
      value1: "",
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: this.pageIndex,
      },
    };
  },
  watch: {
    pageIndex() {
      this.pageParams.pageIndex = this.pageIndex;
    },
    value() {
      this.value1 = this.value;
      // console.log('触发 watch value', this.value1, this.value)
    },
    source() {
      this.Data = this.source;
    },
    listTotal() {
      this.total = this.listTotal;
    },
  },
  mounted() {
    this.value1 = this.value;
    this.Data = this.source;
    this.total = this.listTotal;
  },
  methods: {
    inputText(text) {
      // console.log('inputText sub text', text)
      this.$emit("inputText", text);
    },
    changeSelect(val) {
      this.$emit('changeSelect', val)
    },
    currentPage({ val, text1 }) {
      this.$emit("currentPage", { val, text1 });
    },
    onSelect(data) {
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>